module.exports = __webpack_public_path__ + "img/lak.dd980bce.webp";